import { useTranslation } from 'react-i18next'
import { cn } from '@claritio/frontend/lib/utils'
import { MARK_PATH } from '@claritio/frontend/lib/brandMark'
import type { AgentState } from '@claritio/frontend/hooks/useInterviewPresence'

export default function OrbPresence({ agentState, className }: { agentState: AgentState; className?: string }) {
  const { t } = useTranslation('interview')
  return (
    <div
      role="img"
      aria-label={t('chat.orbLabel')}
      data-state={agentState ?? 'idle'}
      className={cn('clara-mark size-14 shrink-0 md:size-18', className)}
    >
      <svg viewBox="0 0 512 512" aria-hidden="true" className="size-[56%] fill-mist">
        <path d={MARK_PATH} />
      </svg>
    </div>
  )
}
